module.exports = __webpack_public_path__ + "img/ftcash-color.810572f9.png";